import { 
  collection, 
  getDocs, 
  getDoc, 
  doc, 
  query, 
  where,
  Timestamp
} from "firebase/firestore";
import { db } from "../lib/firebase";

const docToProduct = (id, data, variants = []) => ({
  id,
  ...data,
  createdAt: data.createdAt instanceof Timestamp ? data.createdAt.toDate().toISOString() : data.createdAt,
  variants
});

const docToVariant = (id, data) => ({
  id,
  ...data,
});

export const getProducts = async (categoryId = null) => {
  const constraints = [where("isDeleted", "==", false), where("isActive", "==", true)];
  if (categoryId) constraints.push(where("categoryId", "==", categoryId));
  
  const q = query(collection(db, "products"), ...constraints);
  const snap = await getDocs(q);
  
  // Fetch all active categories to map names
  const catSnap = await getDocs(query(collection(db, "categories"), where("isDeleted", "==", false)));
  const categoryMap = catSnap.docs.reduce((acc, d) => {
    acc[d.id] = d.data().name;
    return acc;
  }, {});
  
  return Promise.all(snap.docs.map(async (d) => {
    const data = d.data();
    const variants = await getProductVariants(d.id);
    return docToProduct(d.id, {
      ...data,
      categoryName: categoryMap[data.categoryId] || data.categoryName || "VedhaCultures"
    }, variants);
  }));
};

export const getProductById = async (id) => {
  const d = await getDoc(doc(db, "products", id));
  if (!d.exists()) return null;
  const variants = await getProductVariants(id);
  return docToProduct(d.id, d.data(), variants);
};

export const getProductVariants = async (productId) => {
  const q = query(collection(db, "variants"), where("productId", "==", productId), where("isDeleted", "==", false));
  const snap = await getDocs(q);
  return snap.docs.map(d => docToVariant(d.id, d.data()));
};
